export default __webpack_public_path__ + "static/261554017-b0f11326844f7a10a8b91b40acbe520a.jpeg";